import React from 'react';
import propTypes from 'prop-types';
import SimpleContainer from 'tailwind-components/SimpleContainer/SimpleContainer';
import ExternalLinkButton from 'tailwind-components/ExternalLinkButton/ExternalLinkButton';
import CopyButton from 'tailwind-components/CopyButton/CopyButton';
import PhoneNumberButton from 'tailwind-components/PhoneNumberButton/PhoneNumberButton';
import EmailButton from 'tailwind-components/EmailButton/EmailButton';

export default function SelectedCarrierSidebar({ carrier }) {
  const hasPortalLinks =
    carrier.carrierBrokerPortal ||
    carrier.enrollmentPortal ||
    carrier.omWebsiteLink;

  const hasContactInfo =
    carrier.brokerSupportNumber ||
    carrier.memberSupportNumber ||
    carrier.Broker_Support_Email ||
    carrier.Broker_Commission_Email;

  // united health care uses sircon credentials, so relabel the fields
  const isUnitedHealthCare = carrier.name === 'United Health Care';
  const usernameLabel = isUnitedHealthCare ? 'Sircon Username' : 'Username';
  const passwordLabel = isUnitedHealthCare ? 'Sircon Password' : 'Password';

  return (
    <div className='min-h-0 flex-1 grow h-full'>
      <SimpleContainer className='gap-4'>
        {hasPortalLinks && (
          <SimpleContainer className='flex-row flex-wrap gap-2'>
            {carrier.carrierBrokerPortal && (
              <ExternalLinkButton
                href={carrier.carrierBrokerPortal}
                text='Broker Portal'
                size='xsmall'
                fill={false}
              />
            )}
            {carrier.enrollmentPortal && (
              <ExternalLinkButton
                href={carrier.enrollmentPortal}
                text='Enrollment Portal'
                size='xsmall'
                fill={false}
              />
            )}
            {carrier.omWebsiteLink && (
              <ExternalLinkButton
                href={carrier.omWebsiteLink}
                text='Website Link'
                size='xsmall'
                fill={false}
              />
            )}
          </SimpleContainer>
        )}
        {hasContactInfo && (
          <SimpleContainer>
            <h4 className='m-0 text-lg leading-none'>Contact Information</h4>
            {carrier.brokerSupportNumber && (
              <PhoneNumberButton
                text={carrier.brokerSupportNumber}
                label='Broker Support Phone Number'
              />
            )}
            {carrier.memberSupportNumber && (
              <PhoneNumberButton
                text={carrier.memberSupportNumber}
                label='Member Support Phone Number'
              />
            )}
            {carrier.Broker_Support_Email && (
              <EmailButton
                text={carrier.Broker_Support_Email}
                label='Broker Support Email'
              />
            )}
            {carrier.Broker_Commission_Email && (
              <EmailButton
                text={carrier.Broker_Commission_Email}
                label='Broker Commission Email'
              />
            )}
          </SimpleContainer>
        )}
        {carrier.username && carrier.password && (
          <SimpleContainer>
            <h4 className='m-0 text-lg leading-none'>Login Credentials</h4>
            <CopyButton text={carrier.username} label={usernameLabel} />
            <CopyButton text={carrier.password} label={passwordLabel} />
          </SimpleContainer>
        )}
      </SimpleContainer>
    </div>
  );
}

SelectedCarrierSidebar.propTypes = {
  carrier: propTypes.object.isRequired
};
